import { Box } from "@mui/material"
import type { FC } from "react"

import { formatCostBreakdownCurrency, getShippingTypeLabel } from "../utils"

import { LabelValue } from "./LabelValue"

import type { GrCostBreakdown } from "@/graphql/codegen/graphql"

interface CostBreakdownSummaryProps {
  costBreakdown: GrCostBreakdown
}

export const CostBreakdownSummary: FC<CostBreakdownSummaryProps> = ({ costBreakdown }) => {
  return (
    <Box className='mb-4'>
      <Box className='grid grid-cols-2 gap-x-8 gap-y-3'>
        {!!costBreakdown.shippingCosts?.length && (
          <Box>
            {costBreakdown.shippingCosts.map((shippingCost) => (
              <Box key={shippingCost.grShippingCostId} className='mb-1'>
                <LabelValue label='Shipping type identifier' value={getShippingTypeLabel(shippingCost.shippingType)} />
                <LabelValue label='Shipping Cost' value={formatCostBreakdownCurrency(shippingCost.cost)} />
              </Box>
            ))}
          </Box>
        )}

        <Box>
          <LabelValue label='Import Fees' value={formatCostBreakdownCurrency(costBreakdown.importFees)} />
          <LabelValue label='Insurance' value={formatCostBreakdownCurrency(costBreakdown.insurance)} />
          <LabelValue label='Merchandise Processing Fee' value={formatCostBreakdownCurrency(costBreakdown.mpf)} />
          <LabelValue label='Harbour Maintenance Fee' value={formatCostBreakdownCurrency(costBreakdown.hmf)} />
          {!!costBreakdown.atypicalSurcharges?.length && (
            <>
              {costBreakdown.atypicalSurcharges.map((surcharge) => (
                <LabelValue
                  key={surcharge.grAtypicalSurchargeId}
                  labelClassName='mb-1'
                  label='Miscellaneous'
                  value={`${formatCostBreakdownCurrency(surcharge.amount)}${surcharge.description ? ` - ${surcharge.description}` : ""}`}
                />
              ))}
            </>
          )}
        </Box>
      </Box>
    </Box>
  )
}
